export default __webpack_public_path__ + "static/success-662bf2c25a5f6c93a90b3f25dd3a771a.png";